<div class="modal-groups h-full flex flex-col justify-between">
	<div class="modalHeader w-full flex flex-row justify-between items-center">
		<div class="titleNewModule">
			<span class="font-lato text-2xl font-semibold text-complementary-color-b">{{
				data.type === 'newGroups'
					? translateModal.nameGroup
					: data.type === 'updateGroup' ||
					  data.type === 'updateSelectedGroup' ||
					  data.type === 'updateSubGroup' ||
					  data.type === 'updateSelectedSubGroup'
					? translateModal.nameUpdate
					: translateModal.nameSubGroup + ' ' + data.group.name
			}}</span>
		</div>
		<div class="closeModal pr-1">
			<mat-icon (click)="dialogRef.close()" class="cursor-pointer">close</mat-icon>
		</div>
	</div>
	<div class="body-groups px-6 flex w-full h-full mt-5">
		<div class="image w-1/3 h-full flex items-start justify-center">
			<div
				class="content-drag flex flex-col justify-center pt-4 items-center relative cursor-pointer"
			>
				<div
					class="image border p-5 border-neutral-color-d rounded-2xl w-[calc(140px)] h-[calc(140px)]"
				>
					<img
						imgNotFound
						src="{{ fileUrl }}"
						class="w-[calc(100px)] h-[calc(100px)] object-contain"
					/>
				</div>
				<div class="upload pt-3">
					<div class="flex items-center justify-center px-4 bg-neutral-color-c rounded-lg">
						<mat-icon class="mr-2 material-icons-outlined">backup</mat-icon>
						<span>{{ translateModal.upload }} </span>
						<zf-s3-upload-image
							[version]="'1'"
							[url]="'https://res.cloudinary.com/du4jrqkyo/image/upload/v1549938954/picture.jpg'"
							[urlPresigned]="'https://api-services.mango-soft.com/stage/get-presigned-url'"
							[bucket]="'cdn.mango-soft.com'"
							[folder]="'access-control/files'"
							[client]="'zerofractal'"
							[imageZoom]="false"
							(urlUploaded)="urlUploadedHandle($event)"
							(urlUploadedError)="urlUploadedErrorHandle($event)"
						></zf-s3-upload-image>
					</div>
				</div>
			</div>
		</div>
		<div class="form w-2/3 h-full flex items-start">
			<form action="" [formGroup]="formGroup" class="w-full">
				<div class="form-group">
					<label for="name"> {{ translateModal.name }} <span class="asteriks">*</span></label>
					<input
						type="text"
						id="name"
						class="input-app"
						[placeholder]="translateModal.placeholderName"
						formControlName="name"
					/>
					<div *ngIf="f.name.touched && f.name.invalid" class="alert-error">
						<div *ngIf="f.name.errors?.required">{{ translateModal.nameRequired }}</div>
					</div>
				</div>
				<div class="form-group">
					<label for="name">
						{{ translateModal.email }}
						<!-- <span class="asteriks">*</span> -->
					</label>
					<input
						type="email"
						class="input-app"
						[placeholder]="translateModal.placeholderEmail"
						formControlName="emailTemplade"
					/>
					<!-- <div *ngIf="f.emailTemplade.touched && f.emailTemplade.invalid" class="alert-error">
						<div *ngIf="f.emailTemplade.errors?.required">{{ translateModal.emailRequired }}</div>
						<div *ngIf="f.emailTemplade.errors?.email">{{ translateModal.emailRequired }}</div>
					</div> -->
				</div>
				<div
					class="form-group"
					*ngIf="
						data.type != 'newSubGroups' &&
						data.type != 'updateSubGroup' &&
						data.type != 'updateSelectedSubGroup'
					"
				>
					<label for="name"> {{ translateModal.client }} <span class="asteriks">*</span></label>
					<p-dropdown
						[options]="clients"
						formControlName="client"
						class="w-full"
						placeholder="Clients"
						optionLabel="name"
					>
					</p-dropdown>
				</div>
			</form>
		</div>
	</div>
	<div class="footer-modal">
		<button (click)="dialogRef.close()" class="mg-button secundaryButton mr-3">
			{{ translateModal.buttonCancel }}
		</button>
		<button (click)="save()" class="primaryButton mg-button" [disabled]="formGroup.invalid">
			{{ translateModal.buttonSave }}
		</button>
	</div>
</div>
